const RescheduledPartyBanner = ({ record }: { record: any }) => {
  if (record?.status !== "RESCHEDULED") return null;
  return (
    <div
      style={{
        backgroundColor: "#EFF6FF",
        border: "1px solid #BFDBFE",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "16px",
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "#DBEAFE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#1D4ED8",
          fontWeight: 700,
          fontSize: "18px",
          flexShrink: 0,
        }}
      >
        ↻
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#1E40AF",
            marginBottom: "8px",
          }}
        >
          Party Rescheduled
        </div>

        <div
          style={{
            display: "flex",
            gap: "24px",
            flexWrap: "wrap",
            fontSize: "14px",
          }}
        >
          <div>
            <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Reason:</span>{" "}
            <span style={{ color: "#1E40AF" }}>
              {record?.rescheduleReason || record?.rescheduleReasons || "Not provided"}
            </span>
          </div>

          {record?.rescheduleSubReason && (
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Sub Reason:</span>{" "}
              <span style={{ color: "#1E40AF" }}>{record.rescheduleSubReason}</span>
            </div>
          )}

          {record?.rescheduledBy && (
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Rescheduled By:</span>{" "}
              {record?.rescheduledByType === "ADMIN" ? (
                <a
                  href={`/#/AdminUsers/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : record?.rescheduledByType === "COOK" ? (
                <a
                  href={`/#/Cooks/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : record?.rescheduledByType === "CUSTOMER" ? (
                <a
                  href={`/#/Customers/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : (
                <span style={{ color: "#1E40AF" }}>#{record.rescheduledBy}</span>
              )}
              {record?.rescheduledByType && (
                <span style={{ color: "#6B7280", marginLeft: "6px", fontSize: "12px" }}>
                  ({record.rescheduledByType})
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RescheduledPartyBanner;
